const DragTypes = {
  CHALLENGE: 'challenge',
  TASK: 'task'
};

export default DragTypes;
